// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"73c06acf","990":"80ac22ff"}[chunkId] + ".chunk.js";
};